import React from "react";
import MonthPicker from "../../../../../components/form/month-picker";
import { Select } from "../../../../../components/form/select";
import useResidualStore from "../../../../../stores/residuals";
import { monthAbbrevAndYearToCalendarMonth } from "../formatters";
import styles from "../styles.module.scss";

const ReportMobileHeaderActions = () => {
  const selectedReport = useResidualStore((s) => s.selectedReport);
  const isPaymentAuthorization = selectedReport === "payment-authorization";
  const isInvoiceStatement = selectedReport === "invoice-statement";
  const showReportFilters = isPaymentAuthorization || isInvoiceStatement;
  const officeOptions = useResidualStore((s) => s.paymentAuthOfficeOptions);
  const selectedOffice = useResidualStore((s) => s.paymentAuthSelectedOffice);
  const officesLoading = useResidualStore((s) => s.paymentAuthOfficesLoading);
  const setPaymentAuthSelectedOffice = useResidualStore(
    (s) => s.setPaymentAuthSelectedOffice,
  );
  const setPaymentAuthAppliedPeriod = useResidualStore(
    (s) => s.setPaymentAuthAppliedPeriod,
  );
  const setAgentStatementAppliedPeriod = useResidualStore(
    (s) => s.setAgentStatementAppliedPeriod,
  );

  const onMonthSubmit = ({ year, month: monthAbbrev }) => {
    const next = monthAbbrevAndYearToCalendarMonth(monthAbbrev, year);

    if (!next) {
      return;
    }

    if (selectedReport === "invoice-statement") {
      setAgentStatementAppliedPeriod(next);
    }

    if (selectedReport === "payment-authorization") {
      setPaymentAuthAppliedPeriod(next);
    }
  };

  return (
    <div className={styles.buttonsContainerMobile}>
      <MonthPicker
        key={`report-month-picker-${selectedReport}`}
        variant="smallerFilter"
        onSubmit={onMonthSubmit}
        changeOnSubmit
        showActions
        defaultDate={new Date()}
      />
      {showReportFilters && (
        <div className={styles.officeSelectWrap}>
          <Select
            hideClearButton
            name="office"
            placeholder={officesLoading ? "Loading" : "Office"}
            options={officeOptions}
            value={selectedOffice}
            onChange={setPaymentAuthSelectedOffice}
            disabled={officesLoading}
            secondary
            customClass={styles.officeSelect}
          />
        </div>
      )}
    </div>
  );
};

export default ReportMobileHeaderActions;
